import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexDirective } from './flex.directive';


@NgModule({
    declarations: [FlexDirective],
    imports: [
        CommonModule
    ],
    exports: [
        FlexDirective
    ]
})
export class FlexModule {
}
